import { createFileRoute } from '@tanstack/react-router';
import { requireOrgAdminBeforeLoad } from '../../../lib/org-admin-guard';

export const Route = createFileRoute('/_authenticated/company/templates')({
  beforeLoad: requireOrgAdminBeforeLoad
}).lazy(() => import('./templates.lazy').then((d) => d.Route));
